import React, { useEffect, useState } from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend, ReferenceLine, ResponsiveContainer, CartesianGrid } from "recharts";
import { api } from "@/lib/api";
import { Card } from "@/components/erp/ui";

const COLORS = ["#0ea5e9", "#f59e0b", "#10b981", "#ef4444", "#8b5cf6", "#14b8a6", "#f97316", "#64748b", "#ec4899", "#84cc16"];

export const PerfChart = () => {
  const [months, setMonths] = useState(6);
  const [emps, setEmps] = useState([]);
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get(`/discipline/history?months=${months}${emps.length ? `&employee_id=${emps.join(",")}` : ""}`).then(({ data }) => setD(data)).catch(() => {});
  }, [months, emps]);
  if (!d) return null;
  const rows = d.months.map((m, i) => ({ month: m, ...Object.fromEntries(d.series.map((s) => [s.employee_id, s.points[i].perf])) }));
  return (
    <Card className="p-5 mb-6" data-testid="perf-chart">
      <div className="flex items-center gap-2 mb-3 flex-wrap">
        <span className="font-semibold text-sm">Grafik Nilai Performa per Bulan</span>
        <div className="ml-auto flex gap-1">
          {[3, 6, 12].map((m) => <button key={m} data-testid={`perf-months-${m}`} onClick={() => setMonths(m)} className={`px-3 py-1 rounded-full text-xs ${months === m ? "bg-slate-900 text-white" : "border border-slate-300"}`}>{m} bln</button>)}
        </div>
        {d.manager && <select data-testid="perf-emp-filter" value="" disabled={emps.length >= 4} onChange={(e) => e.target.value && setEmps([...emps, e.target.value])} className="border border-slate-300 rounded-lg px-2 py-1 text-xs">
          <option value="">{emps.length >= 4 ? "Maks. 4 orang" : emps.length ? "+ Bandingkan karyawan" : "Semua karyawan — pilih untuk bandingkan"}</option>
          {d.all.filter((s) => !emps.includes(s.employee_id)).map((s) => <option key={s.employee_id} value={s.employee_id}>{s.name}</option>)}
        </select>}
      </div>
      {d.manager && emps.length > 0 && <div className="flex flex-wrap gap-1.5 mb-3" data-testid="perf-emp-chips">
        {emps.map((id) => <button key={id} type="button" data-testid={`perf-emp-chip-${id}`} onClick={() => setEmps(emps.filter((x) => x !== id))} className="text-xs px-2.5 py-1 rounded-full bg-slate-900 text-white">{d.all.find((s) => s.employee_id === id)?.name || id} ×</button>)}
        <button type="button" data-testid="perf-emp-clear" onClick={() => setEmps([])} className="text-xs text-slate-500 underline">Tampilkan semua</button>
      </div>}
      {d.series.length === 0 ? <div className="text-sm text-slate-400" data-testid="perf-chart-empty">Belum ada data karyawan yang terhubung ke akun ini.</div> : (
        <div className="h-72">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={rows} margin={{ left: -20, right: 10 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis dataKey="month" tick={{ fontSize: 11 }} />
              <YAxis domain={[0, 105]} ticks={[0, 20, 40, 60, 80, 100]} tick={{ fontSize: 11 }} />
              <Tooltip />
              <Legend wrapperStyle={{ fontSize: 11 }} />
              <ReferenceLine y={d.perf_min} stroke="#ef4444" strokeDasharray="4 4" label={{ value: `Batas ${d.perf_min}`, fontSize: 10, fill: "#ef4444" }} />
              {d.series.map((s, i) => <Line key={s.employee_id} type="monotone" dataKey={s.employee_id} name={s.name} stroke={COLORS[i % COLORS.length]} strokeWidth={2} dot={{ r: 3 }} />)}
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </Card>
  );
};
